import React from 'react'
import { TextComp } from 'src/ui/basic/api/Text'

export const Text: TextComp = ({
    children,
    className,
    onClick,
    onTouchStart
}) => (
    <span className={className} onClick={onClick} onTouchStart={onTouchStart}>
        {children}
    </span>
)
